import React, { PureComponent } from 'react';
import memoize from 'memoize-one';

import styled from 'styled-components';

import TabComponent from './tab-component';
import Students from './students';
import Parents from './parents';

const Container = styled.div`
  width: inherit;
  height: inherit;
  margin: 0 auto;
`;

const TABS = [
  {
    id: 'students',
    label: 'Students',
    Component: Students,
  },
  {
    id: 'parents',
    label: 'Parents',
    Component: Parents,
  },
  //  TODO: implement teacher PII page
  //  {
  //    id: 'teachers',
  //    label: 'Teachers',
  //    Component: Teachers,
  //  }
];

const getTabs = memoize((tabs, studentId) =>
  tabs.map(tab => ({
    ...tab,
    link: `/pii-info/${tab.id}`,
  })),
);

export default class BatchAssignment extends PureComponent {
  render() {
    const { activeTab } = this.props;
    const tabs = getTabs(TABS);

    return (
      <Container>
        <TabComponent tabs={tabs} activeTab={activeTab} />
      </Container>
    );
  }
}

BatchAssignment.defaultProps = {
  activeTab: 'students',
};
